const html = document.querySelector('html');
const header = document.querySelector('.header');
const area = document.querySelector('.js-banner, .js-banner-alt');
const Observer = new IntersectionObserver(entries => {
  html.classList.toggle('scrolled', !entries[0].isIntersecting);
}, {
  threshold: 0.8
});
if (area) Observer.observe(area);